import { render, staticRenderFns } from "./ProzessResourceView.vue?vue&type=template&id=4e249504"
import script from "./ProzessResourceView.vue?vue&type=script&lang=js"
export * from "./ProzessResourceView.vue?vue&type=script&lang=js"
import style0 from "./ProzessResourceView.vue?vue&type=style&index=0&id=4e249504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports